import moment from "moment";
import summary_table_pagination from "./summary_table_pagination";

const RowSpanRender = (value, row, index) => {
  let obj = {
    children:
      row.laycan.length == 2 ? moment(row.laycan[0]).format("YYYY/MM") : "N/A",
    attrs: {
      rowSpan: 1,
    },
  };

  if (row.laycan.length == 2) {
    let pos_in_total = col_uitls.data.findIndex((d) => d.id === row.id);
    let total_remaining = col_uitls.data.length - pos_in_total;
    let remaining = summary_table_pagination.pageSize - index;
    let rowSpanCounter = 1;
    for (
      let i = pos_in_total + 1;
      i < pos_in_total + Math.min(remaining, total_remaining);
      i++
    ) {
      if (
        col_uitls.data[i].laycan[0] !== "" &&
        moment(col_uitls.data[i].laycan[0]).format("YYYY/MM") ==
          moment(row.laycan[0]).format("YYYY/MM")
      ) {
        rowSpanCounter++;
      } else {
        break;
      }
    }
    obj.attrs.rowSpan = rowSpanCounter;
    if (
      row.laycan[0] !== "" &&
      index !== 0 &&
      moment(col_uitls.data[pos_in_total - 1].laycan[0]).format("YYYY/MM") ==
        moment(row.laycan[0]).format("YYYY/MM")
    ) {
      obj.attrs.rowSpan = 0;
    }
  }

  return obj;
};

const col_uitls = {
  data: [],
  cols: [
    {
      title: "ID",
      align: "center",
      dataIndex: "id",
    },
    {
      title: "Month By Laycan",
      aligh: "center",
      dataIndex: "laycan",
      customRender: RowSpanRender,
      filters: [],
    },
    {
      title: "Vessel/Voyage/Charterer",
      aligh: "center",
      width: 80,
      scopedSlots: { customRender: "vessel_voyage_charter" },
    },
    {
      title: "Load Port ~ Disc. Port",
      align: "center",
      scopedSlots: { customRender: "load_disc_port" },
    },
    {
      title: "P&L",
      align: "center",
      scopedSlots: { customRender: "pl" },
    },
    {
      title: "B/L and Freight",
      align: "center",
      width: 600,
      scopedSlots: { customRender: "bl" },
    },
  ],

  sort_by_month: (a, b) => {
    if (a.laycan[0] !== "" && b.laycan[0] !== "") {
      return moment(a.laycan[0]).diff(moment(b.laycan[0]));
    } else {
      return true;
    }
  },
};

export default col_uitls;
